import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import IgniteDataTable from '../../common/datatable';
import { history } from '../../../store';
import { downloadIncentives } from '../../../actions/incentives';

class IncentivesList extends Component {
  download(id) {
    this.props.dispatch(downloadIncentives(id));
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Incentive Name',
        format(data, row) {
          return (
            <div>
              { row.attributes.status === 'in_progress' && (
                <OverlayTrigger
                  placement="left"
                  overlay={(
                    <Tooltip id="tooltip" className="tooltip">incentive creation in progress</Tooltip>
                  )}
                >
                  <span className="glyphicon glyphicon-refresh" aria-hidden="true" style={ {marginRight: '0.5em'} }></span>
                </OverlayTrigger>
              )}
              {data}
            </div>
          );
        }
      },
      {
        prop: 'start-date',
        title: 'Start Date',
        width: '100',
        format(data) {
          return (
            <b>
              {moment(data)
                .format('DD/MM/YYYY')}
            </b>
          );
        }
      },
      {
        prop: 'end-date',
        title: 'End Date',
        width: '100',
        format(data) {
          return (
            <b>
              {moment(data)
                .format('DD/MM/YYYY')}
            </b>
          );
        }
      },
      {
        prop: 'kind',
        title: 'Incentive Type',
        width: '130'
      },
      {
        prop: 'total-points-paid',
        title: 'Total Points Paid'
      }
    ];

    const actions = [
      {
        label: 'Details',
        permissions: {
          action: 'update',
          subjectClass: 'Incentive'
        },
        callback: (row) => {
          history.push(`/admin/incentives/${row.id}`);
        }
      },
      {
        label: 'Download',
        color: 'grey',
        permissions: {
          action: 'generate-points-export',
          subjectClass: 'Incentive'
        },
        callback: (row) => {
          this.download(row.id);
        }
      }
    ];

    return (
      <IgniteDataTable
        actions={actions}
        columns={columns}
        data={this.props.incentives}
        dataSize={this.props.pagination.number * this.props.pagination.size}
        hasAttributes
        hideId={false}
        pagination={{
          onPageChange: this.props.onPageChange,
          page: this.props.currentPage,
          sizePerPage: 20,
          paginationShowsTotal: (start, to, total) => (
            <div>
              {start}
              {' '}
              -
              {' '}
              {to}
              {' '}
              of
              {' '}
              {total}
              {' '}
              incentives
            </div>
          ),
        }}
        remote
      />
    );
  }
}

export default connect()(IncentivesList);
